import React, { useState, useEffect, useRef } from "react";
import { AiOutlineMenu } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { FaMoon, FaSun } from "react-icons/fa";
import { IoIosArrowDown } from "react-icons/io";
import { FiUser, FiLogOut } from "react-icons/fi"; // Profile and Logout icons
import { Link } from "react-router-dom";
import { io } from "socket.io-client";
import { IoChatbubbleEllipsesSharp } from "react-icons/io5";
import Swal from "sweetalert2";
import { Modal, Button, Form } from "react-bootstrap";
import { changePassword } from "../Server/api";
import {
  encryptData,
  decryptData,
  generateHMAC,
  saveUserData,
  getDecryptedUserData,
  getUserType
} from "../Utils/encryption";

function Header({ onToggleSidebar }) {
  const [darkMode, setDarkMode] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);
  const [name, setName] = useState("");
  const [AdminNotifiaction, setAdminNotifiaction] = useState(0);
  const [username, setUsername] = useState("");
  const [adminData, setAdminData] = useState(null);
  const socketRef = useRef(null);
  const token = localStorage.getItem("token");
  // const [showOldPassword, setShowOldPassword] = useState(false);
  // const [showNewPassword, setShowNewPassword] = useState(false);
  // const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const email = localStorage.getItem("userEmail");
    if (email) {
      const username = email.split("@")[0];
      setName(username.charAt(0).toUpperCase() + username.slice(1));
    }
  }, []);
  // useEffect(() => {
  //   profileData();
  // }, []);
  useEffect(() => {
    const userData = localStorage.getItem("userType");
    if (userData) {
      try {
        const parsedUser = JSON.parse(userData);
        setUsername(parsedUser.username || parsedUser.email);
        setAdminData(parsedUser);
      } catch (error) {
        console.error("Error parsing user data:", error);
      }
    }
  }, []);

  // const profileData = async () => {
  //   try {
  //     const token = localStorage.getItem("token");
  //     const res = await fetch(`${process.env.REACT_APP_API_URL}admin-profile`, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     const data = await res.json();
  //     if (data.success == "1") {
  //       const psd = localStorage.getItem("psd");
  //       if (psd != data.data.password) {
  //         localStorage.clear();
  //         sessionStorage.clear();
  //         window.location.href = "/login";
  //       }
  //     }
  //   } catch (err) {
  //     console.error("Error fetching market list:", err);
  //   } finally {
  //   }
  // };


  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle("dark-theme");
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDark(document.body.classList.contains("dark-theme"));
    };

    checkDarkMode();

    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });

    return () => observer.disconnect(); // Cleanup on unmount
  }, []);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/login";
  };

  useEffect(() => {
    if (!socketRef.current) {
      try {
        const socket = io("https://sara777chatapi.sindoor7.com", {
          transports: ["websocket"],
          withCredentials: true,
          reconnection: true,
        });

        socketRef.current = socket;

        socket.on("connect", () => {
          console.log("✅ Connected with socket ID:", socket.id);
          socket.emit("join", {
            userId: "user123",
            role: "user",
          });
        });

        socket.on("receive_messageAdminnotifiactionCount", (data) => {
          setAdminNotifiaction(data.totalUnseenAdmin);
        });

        socket.on("disconnect", () => {
          console.log("⚠️ Socket disconnected");
        });

        socket.on("connect_error", (err) => {
          console.error("❌ Connection Error:", err);
        });

        socket.on("error", (err) => {
          console.error("❌ General Socket Error:", err);
        });
      } catch (e) {
        console.error("❌ Exception in socket setup:", e);
      }
    }

    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        console.log("🔌 Socket disconnected on unmount");
        socketRef.current = null;
      }
    };
  }, []);
  const [isOpen, setIsOpen] = useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  // In the handleSubmit function, update it like this:
  const handleSubmit = async () => {
    if (!oldPassword || !newPassword || !confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Missing Fields",
        text: "Please fill all password fields.",
      });
      return;
    }

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Failed",
        text: "Confirm Password Wrong",
      });
      return;
    }

    setIsLoading(true);

    try {
      const secretKey = process.env.REACT_APP_SECRET_KEY;

      const requestData = { oldPassword, newPassword, confirmPassword };

      const encryptedData = encryptData(requestData, secretKey);
      const hmac = generateHMAC(encryptedData, secretKey);

      const token = decryptData(localStorage.getItem("token"), secretKey);

      const response = await fetch(`${process.env.REACT_APP_API_URL}/change-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ encryptedData, hmac }),
      });

      const text = await response.text();
      let resJson = {};

      try {
        resJson = JSON.parse(text);
      } catch (e) {
        throw new Error("Invalid JSON from server");
      }
      if (resJson.encryptedData) {
        const decrypted = decryptData(resJson.encryptedData, secretKey);

        if (!decrypted) {
          throw new Error("Failed to decrypt data");
        }

        if (decrypted.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: decrypted.message
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Failed",
            text: decrypted.message
          });
        }

        return;
      }

      // --------------------------------
      // 🔥 NO encryptedData → Plain JSON (just like your screenshot)
      // --------------------------------
      if (resJson.message) {
        Swal.fire({
          icon: resJson.success ? "success" : "error",
          title: resJson.success ? "Success" : "Error",
          text: resJson.message,
        });
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Unknown response from server",
        });
      }

    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="header" id="header">
      <div className="d-flex justify-content-between px-2 w-100">
        <div className="logo-box d-xl-none d-md-none d-sm-block">
          {/* <Link className="logo-light" to="/dashboard">
            <img
              src={
                isDark
                  ? `${process.env.PUBLIC_URL}/assets/images/logo_dark.png`
                  : `${process.env.PUBLIC_URL}/assets/images/logo.png`
              }
              alt="logo"
              className="logo-lg"
              height="40"
            />
          </Link> */}
        </div>
        <div className=" d-xl-block  d-md-block d-sm-none d-none">
          <div className="togglebutton">
            <AiOutlineMenu onClick={onToggleSidebar} />
          </div>
        </div>
        <div className="linksmode">
          <div className="darkmode" onClick={toggleDarkMode}>
            {darkMode ? <FaSun /> : <FaMoon />}
          </div>
          {/* <div className="notification chat_header_icon">
            <MdNotificationsActive />
          </div> */}
          <div className="chat_header_icon chat_new">
            <Link to="/adminchat">
              <IoChatbubbleEllipsesSharp />
              <span> {AdminNotifiaction}</span>
            </Link>
          </div>
          <div className="profilie" ref={dropdownRef}>
            <div className="profile-header" onClick={toggleDropdown}>
              <div className="profileimage">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/avatar-1.jpg`}
                  alt="Avatar"
                />
              </div>
              <div className="name desktop_device">{username || name}</div>
              <div
                className={`arrowprofile transition-transform duration-300 ${dropdownOpen ? "rotate-180" : ""
                  }`}
              >
                <IoIosArrowDown />
              </div>
            </div>

            {dropdownOpen && (
              <div className="profile-dropdown">
                <div className="dropdown-item mobile_device">
                  <div className="d-flex gap-2 align-items-center">
                    <div className="profileimage">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/avatar-1.jpg`}
                        alt="Avatar"
                      />
                    </div>
                    <div className="name">{name}</div>
                  </div>
                </div>
                <div
                  className="dropdown-item flex items-center gap-2"
                  onClick={() => setIsOpen(true)}
                >
                  <FiUser /> Change Password
                </div>
                <div
                  className="dropdown-item flex items-center gap-2"
                  onClick={handleLogout}
                >
                  <FiLogOut /> Logout
                </div>
              </div>
            )}
          </div>

          <div className="d-xl-none  d-md-none d-sm-block">
            <div className="togglebutton">
              <AiOutlineMenu onClick={onToggleSidebar} />
            </div>
          </div>
        </div>
      </div>


      <Modal show={isOpen} onHide={() => setIsOpen(false)} centered backdrop="static">
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Old Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter old password"
              value={oldPassword}
              onChange={(e) => setOldPassword(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>New Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter new password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Confirm Password</Form.Label>
            <Form.Control
              type="password"
              placeholder="Enter confirm password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setIsOpen(false)}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleSubmit}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

    </div>
  );
}

export default Header;
